<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <h2>見積書一覧</h2>
      </v-col>
      <v-col
        cols="6"
        md="6"
        sm="6"
        class="text-right"
      >
        <v-btn
          :to="{ name: 'CreateQuotation' }"
          class="title-btn red white--text"
        >
          新規登録
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="2"
      >
        <v-text-field
          label="顧客"
          dense
          v-model="params.search"
          @change="getQuotations"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="2"
      >
        <v-select
          label="ステータス"
          dense
          :items="$store.getters.quotationStatus"
          item-text="name"
          item-value="id"
          v-model="params.status"
          @change="getQuotations"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="2"
      >
        <v-select
          label="商品カテゴリ"
          :items=$store.getters.productCategories
          item-text="name"
          item-value="id"
          dense
          v-model="params.productdetail__product__productcategory"
          @change="getQuotations"
        >
        </v-select>
      </v-col>
      <v-col
        cols="2"
      >
        <v-select
          label="商品"
          :items="search_products"
          item-text="name"
          item-value="id"
          dense
          v-model="params.productdetail__product"
          @change="getQuotations"
        >
        </v-select>
      </v-col>
      <v-col
        cols="2"
      >
        <v-select
          label="商品明細"
          dense
          :items="search_productdetails"
          item-text="name"
          item-value="id"
          v-model="params.productdetail"
          @change="getQuotations"
        >
        </v-select>
      </v-col>
      <v-col
        cols="3"
      >
        <v-switch
          label="削除データも表示"
          v-model="contain_deleted"
          dense
          @change="getQuotations"
        >
        </v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :server-items-length="item_total"
          :loading="loading"
          :options.sync="options"
          :footer-props="footer_props"
          disable-sort
          disable-filtering
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          @update:options="getQuotations"
        >
        <template v-slot:item.web_accounts="{ item }">
          <v-btn
            small
            outlined
            color="default"
            :to="{ name: 'EditSubscription', params: {id: item.subscription}}"
            v-if="item.subscription"
          >
            購読済み
          </v-btn>
          <v-btn
            small
            outlined
            color="default"
            :to="{ name: 'CreateSubscription'}"
            v-else
          >
            購読済み
          </v-btn>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            small
            color="default"
            :to="{ name: 'EditQuotation', params: {id: item.id}}"
          >
            詳細
          </v-btn>
          <v-menu
            bottom
            left
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                class="ml-2"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                dense
                @click="deleteConfirm(item)"
                v-if="!item.is_deleted"
              >
                <v-list-item-title>削除する</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        </v-data-table>
        <confirm-dialog
          ref="confirm"
          title="見積もり削除"
          message="見積もりを削除してもいいですか？"
          buttonMessage="削除"
          @confirm="deleteQuotation"
        >
        </confirm-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  components: {
    'confirm-dialog': ConfirmDialog,
  },
  data() {
    return {
      items: [],
      params: {
        search: '',
        status: '',
        productdetail__product__productcategory: '',
        productdetail__product: '',
        productdetail: '',
        search_products: [],
        search_productdetals: [],
        is_deleted: false,
      },
      loading: false,
      item_total: 0,
      options: {
        itemsPerPage: 20,
      },
      search_products: [],
      search_productdetails: [],
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
      headers: [
        {text: "顧客コード", value: "client.cd"},
        {text: "顧客名称", value: "client.name_combined"},
        {text: "電話番号", value: "client.tel"},
        {text: "商品", value: "productdetail.name"},
        {text: "金額", value: "price"},
        {text: "ステータス", value: "status.name"},
        {text: "操作", value: "action", width: "130px"},
      ],
      deleteItem: {},
      contain_deleted: false,
    };
  },
  watch: {
    'params.productdetail__product__productcategory': async function(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/`,
            {
              params: {'productcategory': val},
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              }
            }
          )
          this.search_products = response.data.results;
        } catch(error) {
          console.log(error);
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.search_products = []
      }
    },
    'params.productdetail__product': async function(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/${val}/details/`,
          )
          this.search_productdetails = response.data;
        } catch(error) {
          console.log(error);
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.search_productdetails = [];
      }
    },
    contain_deleted: function() {
      if (this.contain_deleted) {
        this.params.is_deleted = null;
      } else {
        this.params.is_deleted = false;
      }
    }
  },
  methods: {
    async getQuotations() {
      this.loading = true;
      try {
        this.params.page = this.options.page;
        let response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/quotations/`,
          {
            params: this.params,
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            }
          }
        );
        this.item_total = response.data.count
        this.items = response.data.results
        this.loading = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.loading = false;
      }
    },
    deleteConfirm(item) {
      this.deleteItem = item;
      this.$refs.confirm.open();
    },
    async deleteQuotation() {
      try {
        await this.$axios.delete(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/quotations/${this.deleteItem.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            }
          }
        );
        this.$store.dispatch('setSnackbar', {message: "削除されました", type: "success"});
        await this.getQuotations();
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "削除できませんでした", type: "error"});
      }
    }
  }
}
</script>